<template>
    <el-dropdown
        ref="dropdownRef"
        popper-class="custom-dropdown-new dropdown-megamenu"
        :show-arrow="false"
        @visible-change="(v: boolean) => { dropdownOpen = v; $emit('visibleChange', v) }"
    >
        <span class="text-16 inline-flex items-center gap-4px">
            {{ t('common.tools') }}
            <icon-svg-arrow-down class="w-12 h-12 transition-transform duration-200" :class="{ 'rotate-180': dropdownOpen }" />
        </span>
        <template #dropdown>
            <div class="mm-panel">
                <!-- 两栏：开发者工具（磁贴网格）/ 平台服务（竖向列表）（原型 .mega-body.simple-columns） -->
                <div class="mm-body is-simple">
                    <section v-for="(group, gIdx) in dropdownList" :key="gIdx" class="mm-col">
                        <p class="mm-col-title">{{ label(group.name) }}</p>

                        <div :class="group.layout === 'tiles' ? 'mm-tile-grid' : 'mm-list'">
                            <div v-for="(item, iIdx) in itemsOf(group)" :key="iIdx" class="mm-tile" @click="handleEntryClick(item)">
                                <span>
                                    <b class="text-#262642">
                                        {{ label(item.name) }}
                                        <icon-svg-new-tag v-if="item.badge" class="mm-badge" :aria-label="item.badge" />
                                    </b>
                                    <span v-if="item.desc">{{ label(item.desc) }}</span>
                                </span>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { menuList, type DropdownItem } from '@/layout/menuData';

const emit = defineEmits<{
    (e: 'visibleChange', visible: boolean): void;
    (e: 'jumpPage', child: DropdownItem): void;
}>();

const { t } = useI18n();

const dropdownOpen = ref(false);

const dropdownList = menuList.find(m => m.name === 'common.tools')!.dropdownList!;

/**
 * 安全取文案：key 为空/undefined 时返回空串
 * 分类节点没有 desc，直接 t(undefined) 会抛错并导致整页渲染失败
 */
const label = (key?: string) => (key ? t(key) : '');

/** 统一成「条目数组」：分类取其子项，普通条目即自身 */
const itemsOf = (item: DropdownItem): DropdownItem[] => item.list || [];

const dropdownRef = ref();

/** 点击条目：先收起弹层再触发跳转（面板为自定义结构，不会自动关闭） */
const handleEntryClick = (item: DropdownItem) => {
    dropdownRef.value?.handleClose?.();
    emit('jumpPage', item);
};
</script>

<style lang="scss">
/*
 * 工具&平台下拉：样式取自设计原型「FlagOS 2.2 官网导航及首页优化」
 * 三个下拉共用同一弹层类 .dropdown-megamenu，共享基元
 * （--mm-* 设计变量 / .mm-panel / .mm-body.is-simple / .mm-col-title / .mm-tile-grid /
 *  .mm-tile / .mm-list / .mm-card / .mm-badge）定义在 MenuProjects.vue，
 * 这里只补充工具下拉专有的部分。
 */
.dropdown-megamenu {
    /* 原型平台服务为 <button>.platform-tile，浏览器会把 min-height 富余空间上下均分，
       这里用纵向 flex 居中复现同一位置（左栏磁贴仍是顶部对齐） */
    .mm-list .mm-tile {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
